export const timezones = {
  timezones: [
    {
      windowsStandardName: 'Dateline Standard Time',
      olsonName: 'Etc/GMT+12',
      windowsDisplayName: '(GMT -12:00) International Date Line West',
    },
    {
      windowsStandardName: 'GMT -11',
      olsonName: 'Etc/GMT+11',
      windowsDisplayName: '(GMT -11:00) Coordinated Universal Time-11',
    },
    {
      windowsStandardName: 'Hawaiian Standard Time',
      olsonName: 'Pacific/Honolulu',
      windowsDisplayName: '(GMT -10:00) Hawaii',
    },
    {
      windowsStandardName: 'Alaskan Standard Time',
      olsonName: 'America/Anchorage',
      windowsDisplayName: '(GMT -09:00) Alaska',
    },
    {
      windowsStandardName: 'Pacific Standard Time (Mexico)',
      olsonName: 'America/Tijuana',
      windowsDisplayName: '(GMT -08:00) Baja California',
    },
    {
      windowsStandardName: 'Pacific Standard Time',
      olsonName: 'America/Los_Angeles',
      windowsDisplayName: '(GMT -08:00) Pacific Time (US & Canada)',
    },
    {
      windowsStandardName: 'US Mountain Standard Time',
      olsonName: 'America/Phoenix',
      windowsDisplayName: '(GMT -07:00) Arizona',
    },
    {
      windowsStandardName: 'Mountain Standard Time (Mexico)',
      olsonName: 'America/Chihuahua',
      windowsDisplayName: '(GMT -07:00) Chihuahua, La Paz, Mazatlan',
    },
    {
      windowsStandardName: 'Mountain Standard Time',
      olsonName: 'America/Denver',
      windowsDisplayName: '(GMT -07:00) Mountain Time (US & Canada)',
    },
    {
      windowsStandardName: 'Central America Standard Time',
      olsonName: 'America/Guatemala',
      windowsDisplayName: '(GMT -06:00) Central America',
    },
    {
      windowsStandardName: 'Central Standard Time',
      olsonName: 'America/Chicago',
      windowsDisplayName: '(GMT -06:00) Central Time (US & Canada)',
    },
    {
      windowsStandardName: 'Central Standard Time (Mexico)',
      olsonName: 'America/Mexico_City',
      windowsDisplayName: '(GMT -06:00) Guadalajara, Mexico City, Monterrey',
    },
    {
      windowsStandardName: 'Canada Central Standard Time',
      olsonName: 'America/Regina',
      windowsDisplayName: '(GMT -06:00) Saskatchewan',
    },
    {
      windowsStandardName: 'SA Pacific Standard Time',
      olsonName: 'America/Bogota',
      windowsDisplayName: '(GMT -05:00) Bogota, Lima, Quito',
    },
    {
      windowsStandardName: 'Eastern Standard Time',
      olsonName: 'America/New_York',
      windowsDisplayName: '(GMT -05:00) Eastern Time (US & Canada)',
    },
    {
      windowsStandardName: 'US Eastern Standard Time',
      olsonName: 'America/Indianapolis',
      windowsDisplayName: '(GMT -05:00) Indiana (East)',
    },
    {
      windowsStandardName: 'Paraguay Standard Time',
      olsonName: 'America/Asuncion',
      windowsDisplayName: '(GMT -04:00) Asuncion',
    },
    {
      windowsStandardName: 'Atlantic Standard Time',
      olsonName: 'America/Halifax',
      windowsDisplayName: '(GMT -04:00) Atlantic Time (Canada)',
    },
    {
      windowsStandardName: 'Central Brazilian Standard Time',
      olsonName: 'America/Cuiaba',
      windowsDisplayName: '(GMT -04:00) Cuiaba',
    },
    {
      windowsStandardName: 'SA Western Standard Time',
      olsonName: 'America/La_Paz',
      windowsDisplayName: '(GMT -04:00) Georgetown, La Paz, Manaus, San Juan',
    },
    {
      windowsStandardName: 'Pacific SA Standard Time',
      olsonName: 'America/Santiago',
      windowsDisplayName: '(GMT -04:00) Santiago',
    },
    {
      windowsStandardName: 'Venezuela Standard Time',
      olsonName: 'America/Caracas',
      windowsDisplayName: '(GMT -04:30) Caracas',
    },
    {
      windowsStandardName: 'Newfoundland Standard Time',
      olsonName: 'America/St_Johns',
      windowsDisplayName: '(GMT -03:30) Newfoundland',
    },
    {
      windowsStandardName: 'E. South America Standard Time',
      olsonName: 'America/Sao_Paulo',
      windowsDisplayName: '(GMT -03:00) Brasilia',
    },
    {
      windowsStandardName: 'Argentina Standard Time',
      olsonName: 'America/Buenos_Aires',
      windowsDisplayName: '(GMT -03:00) Buenos Aires',
    },
    {
      windowsStandardName: 'SA Eastern Standard Time',
      olsonName: 'America/Cayenne',
      windowsDisplayName: '(GMT -03:00) Cayenne, Fortaleza',
    },
    {
      windowsStandardName: 'Greenland Standard Time',
      olsonName: 'America/Godthab',
      windowsDisplayName: '(GMT -03:00) Greenland',
    },
    {
      windowsStandardName: 'Montevideo Standard Time',
      olsonName: 'America/Montevideo',
      windowsDisplayName: '(GMT -03:00) Montevideo',
    },
    {
      windowsStandardName: 'GMT -02',
      olsonName: 'Etc/GMT+2',
      windowsDisplayName: '(GMT -02:00) Coordinated Universal Time-02',
    },
    {
      windowsStandardName: 'Mid-Atlantic Standard Time',
      olsonName: 'Etc/GMT+2',
      windowsDisplayName: '(GMT -02:00) Mid-Atlantic',
    },
    {
      windowsStandardName: 'Azores Standard Time',
      olsonName: 'Atlantic/Azores',
      windowsDisplayName: '(GMT -01:00) Azores',
    },
    {
      windowsStandardName: 'Cape Verde Standard Time',
      olsonName: 'Atlantic/Cape_Verde',
      windowsDisplayName: '(GMT -01:00) Cape Verde Is.',
    },
    {
      windowsStandardName: 'Morocco Standard Time',
      olsonName: 'Africa/Casablanca',
      windowsDisplayName: '(GMT) Casablanca',
    },
    {
      windowsStandardName: 'GMT ',
      olsonName: 'Etc/GMT',
      windowsDisplayName: '(GMT) Coordinated Universal Time',
    },
    {
      windowsStandardName: 'GMT Standard Time',
      olsonName: 'Europe/London',
      windowsDisplayName: '(GMT) Dublin, Edinburgh, Lisbon, London',
    },
    {
      windowsStandardName: 'Greenwich Standard Time',
      olsonName: 'Atlantic/Reykjavik',
      windowsDisplayName: '(GMT) Monrovia, Reykjavik',
    },
    {
      windowsStandardName: 'W. Europe Standard Time',
      olsonName: 'Europe/Berlin',
      windowsDisplayName:
        '(GMT +01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    },
    {
      windowsStandardName: 'Central Europe Standard Time',
      olsonName: 'Europe/Budapest',
      windowsDisplayName:
        '(GMT +01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    },
    {
      windowsStandardName: 'Romance Standard Time',
      olsonName: 'Europe/Paris',
      windowsDisplayName: '(GMT +01:00) Brussels, Copenhagen, Madrid, Paris',
    },
    {
      windowsStandardName: 'Central European Standard Time',
      olsonName: 'Europe/Warsaw',
      windowsDisplayName: '(GMT +01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    },
    {
      windowsStandardName: 'W. Central Africa Standard Time',
      olsonName: 'Africa/Lagos',
      windowsDisplayName: '(GMT +01:00) West Central Africa',
    },
    {
      windowsStandardName: 'Jordan Standard Time',
      olsonName: 'Asia/Amman',
      windowsDisplayName: '(GMT +02:00) Amman',
    },
    {
      windowsStandardName: 'Middle East Standard Time',
      olsonName: 'Asia/Beirut',
      windowsDisplayName: '(GMT +02:00) Beirut',
    },
    {
      windowsStandardName: 'Egypt Standard Time',
      olsonName: 'Africa/Cairo',
      windowsDisplayName: '(GMT +02:00) Cairo',
    },
    {
      windowsStandardName: 'Syria Standard Time',
      olsonName: 'Asia/Damascus',
      windowsDisplayName: '(GMT +02:00) Damascus',
    },
    {
      windowsStandardName: 'South Africa Standard Time',
      olsonName: 'Africa/Johannesburg',
      windowsDisplayName: '(GMT +02:00) Harare, Pretoria',
    },
    {
      windowsStandardName: 'FLE Standard Time',
      olsonName: 'Europe/Kiev',
      windowsDisplayName:
        '(GMT +02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    },
    {
      windowsStandardName: 'Israel Standard Time',
      olsonName: 'Asia/Jerusalem',
      windowsDisplayName: '(GMT +02:00) Jerusalem',
    },
    {
      windowsStandardName: 'Namibia Standard Time',
      olsonName: 'Africa/Windhoek',
      windowsDisplayName: '(GMT +02:00) Windhoek',
    },
    {
      windowsStandardName: 'GTB Standard Time',
      olsonName: 'Europe/Istanbul',
      windowsDisplayName: '(GMT +02:00) Athens, Bucharest, Istanbul',
    },
    {
      windowsStandardName: 'E. Europe Standard Time',
      olsonName: 'Europe/Minsk',
      windowsDisplayName: '(GMT +02:00) Minsk',
    },
    {
      windowsStandardName: 'Arabic Standard Time',
      olsonName: 'Asia/Baghdad',
      windowsDisplayName: '(GMT +03:00) Baghdad',
    },
    {
      windowsStandardName: 'Arab Standard Time',
      olsonName: 'Asia/Riyadh',
      windowsDisplayName: '(GMT +03:00) Kuwait, Riyadh',
    },
    {
      windowsStandardName: 'Russian Standard Time',
      olsonName: 'Europe/Moscow',
      windowsDisplayName: '(GMT +03:00) Moscow, St. Petersburg, Volgograd',
    },
    {
      windowsStandardName: 'E. Africa Standard Time',
      olsonName: 'Africa/Nairobi',
      windowsDisplayName: '(GMT +03:00) Nairobi',
    },
    {
      windowsStandardName: 'Iran Standard Time',
      olsonName: 'Asia/Tehran',
      windowsDisplayName: '(GMT +03:30) Tehran',
    },
    {
      windowsStandardName: 'Arabian Standard Time',
      olsonName: 'Asia/Dubai',
      windowsDisplayName: '(GMT +04:00) Abu Dhabi, Muscat',
    },
    {
      windowsStandardName: 'Azerbaijan Standard Time',
      olsonName: 'Asia/Baku',
      windowsDisplayName: '(GMT +04:00) Baku',
    },
    {
      windowsStandardName: 'Mauritius Standard Time',
      olsonName: 'Indian/Mauritius',
      windowsDisplayName: '(GMT +04:00) Port Louis',
    },
    {
      windowsStandardName: 'Georgian Standard Time',
      olsonName: 'Asia/Tbilisi',
      windowsDisplayName: '(GMT +04:00) Tbilisi',
    },
    {
      windowsStandardName: 'Caucasus Standard Time',
      olsonName: 'Asia/Yerevan',
      windowsDisplayName: '(GMT +04:00) Yerevan',
    },
    {
      windowsStandardName: 'Afghanistan Standard Time',
      olsonName: 'Asia/Kabul',
      windowsDisplayName: '(GMT +04:30) Kabul',
    },
    {
      windowsStandardName: 'Ekaterinburg Standard Time',
      olsonName: 'Asia/Yekaterinburg',
      windowsDisplayName: '(GMT +05:00) Ekaterinburg',
    },
    {
      windowsStandardName: 'Pakistan Standard Time',
      olsonName: 'Asia/Karachi',
      windowsDisplayName: '(GMT +05:00) Islamabad, Karachi',
    },
    {
      windowsStandardName: 'West Asia Standard Time',
      olsonName: 'Asia/Tashkent',
      windowsDisplayName: '(GMT +05:00) Tashkent',
    },
    {
      windowsStandardName: 'India Standard Time',
      olsonName: 'Asia/Calcutta',
      windowsDisplayName: '(GMT +05:30) Chennai, Kolkata, Mumbai, New Delhi',
    },
    {
      windowsStandardName: 'Sri Lanka Standard Time',
      olsonName: 'Asia/Colombo',
      windowsDisplayName: '(GMT +05:30) Sri Jayawardenepura',
    },
    {
      windowsStandardName: 'Nepal Standard Time',
      olsonName: 'Asia/Katmandu',
      windowsDisplayName: '(GMT +05:45) Kathmandu',
    },
    {
      windowsStandardName: 'Central Asia Standard Time',
      olsonName: 'Asia/Almaty',
      windowsDisplayName: '(GMT +06:00) Astana',
    },
    {
      windowsStandardName: 'Bangladesh Standard Time',
      olsonName: 'Asia/Dhaka',
      windowsDisplayName: '(GMT +06:00) Dhaka',
    },
    {
      windowsStandardName: 'Myanmar Standard Time',
      olsonName: 'Asia/Rangoon',
      windowsDisplayName: '(GMT +06:30) Yangon (Rangoon)',
    },
    {
      windowsStandardName: 'N. Central Asia Standard Time',
      olsonName: 'Asia/Novosibirsk',
      windowsDisplayName: '(GMT +06:00) Novosibirsk',
    },
    {
      windowsStandardName: 'SE Asia Standard Time',
      olsonName: 'Asia/Bangkok',
      windowsDisplayName: '(GMT +07:00) Bangkok, Hanoi, Jakarta',
    },
    {
      windowsStandardName: 'North Asia Standard Time',
      olsonName: 'Asia/Krasnoyarsk',
      windowsDisplayName: '(GMT +07:00) Krasnoyarsk',
    },
    {
      windowsStandardName: 'China Standard Time',
      olsonName: 'Asia/Shanghai',
      windowsDisplayName: '(GMT +08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    },
    {
      windowsStandardName: 'North Asia East Standard Time',
      olsonName: 'Asia/Irkutsk',
      windowsDisplayName: '(GMT +08:00) Irkutsk',
    },
    {
      windowsStandardName: 'Singapore Standard Time',
      olsonName: 'Asia/Singapore',
      windowsDisplayName: '(GMT +08:00) Kuala Lumpur, Singapore',
    },
    {
      windowsStandardName: 'W. Australia Standard Time',
      olsonName: 'Australia/Perth',
      windowsDisplayName: '(GMT +08:00) Perth',
    },
    {
      windowsStandardName: 'Taipei Standard Time',
      olsonName: 'Asia/Taipei',
      windowsDisplayName: '(GMT +08:00) Taipei',
    },
    {
      windowsStandardName: 'Ulaanbaatar Standard Time',
      olsonName: 'Asia/Ulaanbaatar',
      windowsDisplayName: '(GMT +08:00) Ulaanbaatar',
    },
    {
      windowsStandardName: 'Tokyo Standard Time',
      olsonName: 'Asia/Tokyo',
      windowsDisplayName: '(GMT +09:00) Osaka, Sapporo, Tokyo',
    },
    {
      windowsStandardName: 'Korea Standard Time',
      olsonName: 'Asia/Seoul',
      windowsDisplayName: '(GMT +09:00) Seoul',
    },
    {
      windowsStandardName: 'Yakutsk Standard Time',
      olsonName: 'Asia/Yakutsk',
      windowsDisplayName: '(GMT +09:00) Yakutsk',
    },
    {
      windowsStandardName: 'Cen. Australia Standard Time',
      olsonName: 'Australia/Adelaide',
      windowsDisplayName: '(GMT +09:30) Adelaide',
    },
    {
      windowsStandardName: 'AUS Central Standard Time',
      olsonName: 'Australia/Darwin',
      windowsDisplayName: '(GMT +09:30) Darwin',
    },
    {
      windowsStandardName: 'E. Australia Standard Time',
      olsonName: 'Australia/Brisbane',
      windowsDisplayName: '(GMT +10:00) Brisbane',
    },
    {
      windowsStandardName: 'AUS Eastern Standard Time',
      olsonName: 'Australia/Sydney',
      windowsDisplayName: '(GMT +10:00) Canberra, Melbourne, Sydney',
    },
    {
      windowsStandardName: 'West Pacific Standard Time',
      olsonName: 'Pacific/Port_Moresby',
      windowsDisplayName: '(GMT +10:00) Guam, Port Moresby',
    },
    {
      windowsStandardName: 'Tasmania Standard Time',
      olsonName: 'Australia/Hobart',
      windowsDisplayName: '(GMT +10:00) Hobart',
    },
    {
      windowsStandardName: 'Vladivostok Standard Time',
      olsonName: 'Asia/Vladivostok',
      windowsDisplayName: '(GMT +10:00) Vladivostok',
    },
    {
      windowsStandardName: 'Magadan Standard Time',
      olsonName: 'Asia/Magadan',
      windowsDisplayName: '(GMT +11:00) Magadan',
    },
    {
      windowsStandardName: 'Central Pacific Standard Time',
      olsonName: 'Pacific/Guadalcanal',
      windowsDisplayName: '(GMT +11:00) Solomon Is., New Caledonia',
    },
    {
      windowsStandardName: 'New Zealand Standard Time',
      olsonName: 'Pacific/Auckland',
      windowsDisplayName: '(GMT +12:00) Auckland, Wellington',
    },
    {
      windowsStandardName: 'GMT +12',
      olsonName: 'Etc/GMT-12',
      windowsDisplayName: '(GMT +12:00) Coordinated Universal Time+12',
    },
    {
      windowsStandardName: 'Fiji Standard Time',
      olsonName: 'Pacific/Fiji',
      windowsDisplayName: '(GMT +12:00) Fiji, Marshall Is.',
    },
    {
      windowsStandardName: 'Kamchatka Standard Time',
      olsonName: 'Asia/Kamchatka',
      windowsDisplayName: '(GMT +12:00) Petropavlovsk-Kamchatsky - Old',
    },
    {
      windowsStandardName: 'Tonga Standard Time',
      olsonName: 'Pacific/Tongatapu',
      windowsDisplayName: "(GMT +13:00) Nuku'alofa",
    },
    {
      windowsStandardName: 'Samoa Standard Time',
      olsonName: 'Pacific/Apia',
      windowsDisplayName: '(GMT -11:00) Samoa',
    },
  ],
};
